var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import CreditCard from '@mui/icons-material/CreditCardRounded';
import ReceiptIcon from '@mui/icons-material/ReceiptRounded';
import { Box, Button, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography, } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { format } from 'date-fns';
import { sv } from 'date-fns/locale';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useApiAbort from '../../Api/Core/useApiAbort';
import GoBack from '../../Components/GoBack';
import Header from '../../Components/Header';
import TableMessage from '../../Components/TableMessage/TableMessage';
import Wrapper from '../../Components/Wrapper';
import { useApi } from '../../Context/APIContext';
import { MakhazinTheme } from '../../theme';
import { useStyles } from './MyPayments.styles';
const getStatusString = (status) => {
    if (status === 'Completed') {
        return 'Genomförd';
    }
    else if (status === 'Pending') {
        return 'Väntande';
    }
    else if (status === 'Rejected') {
        return 'Avvisad';
    }
    else if (status === 'Failed') {
        return 'Misslyckad';
    }
    else if (status === 'Scheduled') {
        return 'Kommande';
    }
};
export const MyPayments = () => {
    const api = useApi();
    const abortController = useApiAbort();
    const navigate = useNavigate();
    if (api) {
        api.setAbortController(abortController.current);
    }
    const classes = useStyles();
    const smDown = useMediaQuery(MakhazinTheme.breakpoints.down('sm'));
    const [payments, setPayments] = useState([]);
    useEffect(() => {
        const fetchPayments = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!api)
                return;
            try {
                var result = yield api.getPayments();
                if (result) {
                    setPayments(result.payments);
                }
                else {
                    setPayments([]);
                }
            }
            catch (exception) {
                abortController.current.abort();
                setPayments([]);
            }
        });
        fetchPayments();
    }, [api, abortController]);
    const navigateToReceipt = (transactionId) => {
        return () => {
            navigate('/mypages/mypayments/' + transactionId);
        };
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null,
            React.createElement(GoBack, { to: "/mypages" }),
            React.createElement(Typography, { variant: "h1", sx: classes.title }, "Mina betalningar")),
        React.createElement(Wrapper, null,
            !smDown ? (React.createElement(Box, { sx: classes.tableWrapper },
                React.createElement(Table, null,
                    React.createElement(TableHead, null,
                        React.createElement(TableRow, null,
                            React.createElement(TableCell, null, "Datum"),
                            React.createElement(TableCell, null, "Pris"),
                            React.createElement(TableCell, null, "Status"),
                            React.createElement(TableCell, null, "Giltig till"),
                            React.createElement(TableCell, null, "Abonnemang"),
                            React.createElement(TableCell, null, "Transaktion"),
                            React.createElement(TableCell, null))),
                    React.createElement(TableBody, null, payments.map((x, index) => {
                        return (React.createElement(TableRow, { key: index },
                            React.createElement(TableCell, null, x.lastRun
                                ? format(new Date(x.lastRun), 'PPpp', { locale: sv })
                                : x.nextRun
                                    ? format(new Date(x.nextRun), 'PP', { locale: sv })
                                    : ''),
                            React.createElement(TableCell, null, x.price),
                            React.createElement(TableCell, null, getStatusString(x.status)),
                            React.createElement(TableCell, null, format(new Date(x.validTo), 'PPpp', { locale: sv })),
                            React.createElement(TableCell, null, x.orderReference),
                            React.createElement(TableCell, null, x.transactionId),
                            (x.status === 'Completed' && (React.createElement(TableCell, { align: "right" },
                                React.createElement(Tooltip, { title: "Receipt" },
                                    React.createElement(IconButton, { onClick: navigateToReceipt(x.transactionId), "aria-label": "Receipt" },
                                        React.createElement(ReceiptIcon, null)))))) || React.createElement(TableCell, { align: "right" })));
                    }))))) : (React.createElement(React.Fragment, null, payments.map((x, index) => {
                return (React.createElement(Box, { component: "div", sx: classes.mobileRow, key: index },
                    React.createElement(Box, { component: "ul", sx: classes.mobileList },
                        React.createElement("li", null,
                            React.createElement(Typography, { sx: classes.header }, "Datum:"),
                            React.createElement(Typography, { sx: classes.value }, x.lastRun
                                ? format(new Date(x.lastRun), 'PPpp', { locale: sv })
                                : x.nextRun
                                    ? format(new Date(x.nextRun), 'PP', { locale: sv })
                                    : '')),
                        React.createElement("li", null,
                            React.createElement(Typography, { sx: classes.header }, "Pris:"),
                            React.createElement(Typography, { sx: classes.value }, x.price)),
                        React.createElement("li", null,
                            React.createElement(Typography, { sx: classes.header }, "Status:"),
                            React.createElement(Typography, { sx: classes.value }, getStatusString(x.status))),
                        React.createElement("li", null,
                            React.createElement(Typography, { sx: classes.header }, "Giltig till:"),
                            React.createElement(Typography, { sx: classes.value }, format(new Date(x.validTo), 'PPpp', { locale: sv }))),
                        React.createElement("li", null,
                            React.createElement(Typography, { sx: classes.header }, "Abonnemang:"),
                            React.createElement(Typography, { sx: classes.value }, x.orderReference)),
                        React.createElement("li", null,
                            React.createElement(Typography, { sx: classes.header }, "Transaktions id:"),
                            React.createElement(Typography, { sx: classes.value }, x.transactionId)),
                        React.createElement(Box, { component: "div", sx: classes.receipt },
                            React.createElement(Button, { color: "primary", variant: "outlined", sx: classes.button }, "Visa kvitto")))));
            }))),
            !payments ||
                (payments.length === 0 && (React.createElement(TableMessage, { text: "Du har inga betalningar", icon: React.createElement(CreditCard, { fontSize: "large" }) }))))));
};
export default MyPayments;
